import styled from 'styled-components';
import {
  COLOR,
  FONT_SIZE,
  LAYOUT,
  RADIUS,
  SHADOW,
  SPACING,
} from '../../../constants/theme';

export const Card = styled.section`
  background: ${COLOR.surface};
  border: 1px solid ${COLOR.border};
  border-radius: ${RADIUS.card};
  box-shadow: ${SHADOW.card};
  margin-bottom: ${SPACING.lg};
`;

export const CardBody = styled.div`
  padding: ${SPACING.xl};
`;

export const SectionTitle = styled.h2`
  margin: 0 0 ${SPACING.lg};
  font-size: ${FONT_SIZE.sectionTitle};
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${COLOR.textSecondary};
`;

export const OptionalMark = styled.span`
  margin-left: ${SPACING.xs};
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  color: ${COLOR.textMuted};
`;

export const Divider = styled.div`
  border-top: 1px solid ${COLOR.border};
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: ${FONT_SIZE.pageTitle};
  font-weight: 700;
  color: ${COLOR.navy};
`;

export const PageSubtitle = styled.p`
  margin: ${SPACING.sm} 0 0;
  font-size: ${FONT_SIZE.value};
  color: ${COLOR.textSecondary};
`;

export const PageHead = styled.header`
  margin: ${SPACING.xl} 0 ${SPACING.lg};
`;

export const PageShell = styled.div`
  max-width: ${LAYOUT.maxWidth};
  margin: 0 auto;
  padding: 0 ${LAYOUT.gutter} ${SPACING.xxxl};
`;

export const HelpText = styled.p`
  margin: ${SPACING.lg} 0 0;
  font-size: ${FONT_SIZE.hint};
  line-height: 1.5;
  text-align: center;
  color: ${COLOR.textSecondary};

  b {
    font-weight: 700;
    color: ${COLOR.text};
  }

  a {
    color: ${COLOR.primary};
  }
`;
